import Image from "next/image";

import { cn } from "@/lib/utils";
import { CaseStudy } from "@/pages/case-studies/[slug]";
import { clashGrotesk, jakartaSans } from "@/styles/fonts";
import { formatImageUrl } from "../blog/Util";

export default function CTA({
  testimonial,
  image,
  companyName,
  ownerName,
  generalReboltStat,
}: Pick<CaseStudy, "testimonial" | "companyName" | "ownerName" | "generalReboltStat"> & { image: string }) {
  return (
    <section className={cn("px-4 pt-0 pb-12 md:py-32 bg-white", jakartaSans.variable, clashGrotesk.variable)}>
      <div className="max-w-6xl w-full flex flex-col gap-12 md:gap-24 items-center justify-center mx-auto rounded-3xl bg-ash-100">
        <section className="flex flex-col md:flex-row text-center w-full">
          {image && (
            <div className="rounded-3xl relative  md:min-h-[550px] w-full md:w-1/3 ">
              <Image
                width={200}
                height={200}
                sizes="(max-width: 768px) 90vw, 45vw"
                className="rounded-3xl shadow-sm w-full h-full object-cover"
                src={`${formatImageUrl(image)}`}
                alt={`${companyName} ${ownerName}`}
                loading="eager"
                priority
              />
              <div className="absolute top-0 left-0 right-0 bottom-0 bg-linear-to-t from-ash-900/80 to-ash-900/0 rounded-3xl flex flex-col items-start justify-end p-8">
                <p className="text-white font-clash font-medium text-xl">{ownerName}</p>
                <p className="text-ash-300 font-medium">{companyName}</p>
              </div>
            </div>
          )}
          <div className="max-w-7xl flex-col md:flex-row flex gap-6 md:w-2/3 px-4 md:px-10 py-8">
            <div className="flex flex-col text-start items-start justify-between gap-12 w-full text-ash-900">
              <p className="text-3xl md:text-5xl tracking-tight font-clash font-medium">&quot;{testimonial}&quot;</p>
              <div className="flex flex-row flex-wrap gap-12 md:max-w-xs">
                {generalReboltStat.map((stat, index) => (
                  <div key={index} className="flex flex-col gap-1">
                    <p className="text-4xl font-clash font-semibold text-ash-900">{stat.fields.header}</p>
                    <p className="text-medium text-ash-700">{stat.fields.subheader}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}
